import { ROUTES } from '@/lib/routes';

import {
    MiningAndPumpingSVG,
    WellLoggingOperationsSVG,
    TechnologicalEfficiencyGTMSVG,
    MapSVG,
    DesaturationCharacteristicsSVG,
    OilProductionLossSVG,
    FactorAnalysisSVG,
    GsrSVG,
    WellsViewSVG,
    UrzmSVG,
    GeoLayers,
} from './icons';

export const BUTTON_ITEMS = [
    {
        id: 1,
        title: 'Добыча/закачка',
        keyName: 'R',
        path: ROUTES.MINING_AND_PUMPING,
        relatedPaths: [ROUTES.MINING_AND_PUMPING, ROUTES.SUMMARY_MODE],
        Icon: MiningAndPumpingSVG,
    },
    {
        id: 2,
        title: 'Эффективность ГТМ',
        keyName: 'Y',
        path: ROUTES.TECHNOLOGICAL_EFFICIENCY_GTM,
        relatedPaths: [ROUTES.TECHNOLOGICAL_EFFICIENCY_GTM],
        Icon: TechnologicalEfficiencyGTMSVG,
    },
    {
        id: 3,
        title: 'Диаграммы каротажа',
        keyName: 'T',
        path: ROUTES.WELL_LOGGING_OPERATIONS,
        relatedPaths: [ROUTES.WELL_LOGGING_OPERATIONS],
        Icon: WellLoggingOperationsSVG,
    },
    {
        id: 4,
        title: 'Карта',
        keyName: 'U',
        path: ROUTES.MAP_GENERATION,
        relatedPaths: [ROUTES.MAP_GENERATION],
        Icon: MapSVG,
    },
    {
        id: 5,
        title: 'Потери нефти',
        keyName: 'O',
        path: ROUTES.OIL_PRODUCTION_LOSS,
        relatedPaths: [ROUTES.OIL_PRODUCTION_LOSS],
        Icon: OilProductionLossSVG,
    },
    {
        id: 6,
        title: 'Характеристики вытеснения',
        keyName: 'I',
        path: ROUTES.DESATURATION_CHARACTERISTICS,
        relatedPaths: [ROUTES.DESATURATION_CHARACTERISTICS],
        Icon: DesaturationCharacteristicsSVG,
    },
    {
        id: 7,
        title: 'Вид скважины',
        keyName: 'V',
        path: ROUTES.WELLS_VIEW,
        relatedPaths: [ROUTES.WELLS_VIEW],
        Icon: WellsViewSVG,
    },
    {
        id: 8,
        title: 'ГСР',
        keyName: 'G',
        path: ROUTES.GSR,
        relatedPaths: [ROUTES.GSR],
        Icon: GsrSVG,
    },
    {
        id: 9,
        title: 'Факторный анализ',
        keyName: 'F',
        path: ROUTES.FACTOR_ANALYSIS,
        relatedPaths: [ROUTES.FACTOR_ANALYSIS],
        Icon: FactorAnalysisSVG,
    },
    {
        id: 10,
        title: 'УРЗМ',
        keyName: 'U',
        path: ROUTES.URZM,
        relatedPaths: [ROUTES.URZM],
        Icon: UrzmSVG,
    },
    {
        id: 11,
        title: 'Геологические профиля',
        keyName: 'G',
        path: ROUTES.GEOTEST,
        relatedPaths: [ROUTES.GEOTEST],
        Icon: GeoLayers,
    },
];

export const BUTTON_ITEM_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
export const MODULES = {
    REPORTS: 0,
    MINING_AND_PUMPING: 1,
    TECHNOLOGICAL_EFFICIENCY_GTM: 2,
    WELL_LOGGING_OPERATIONS: 3,
    MAP_GENERATION: 4,
    OIL_PRODUCTION_LOSS: 5,
    DESATURATION_CHARACTERISTICS: 6,
    WELLS_VIEW: 7,
    GSR: 8,
    FACTOR_ANALYSIS: 9,
    URZM: 10,
    GEOTEST: 11,
};
